import React, { useEffect, useState } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { get, post } from '../../services/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Checkout = () => {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();

const baseUrl = process.env.REACT_APP_LIVE_DOMAIN_URL
  const fetchItems = async (id) => {
    try
    {
      const response = await get(
            `Order/cart-items/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          console.log("item", response)
          setCartItems(response)
        } catch (error) {
          setCartItems([])
          console.error("Error fetching items:", error);
        }
      };
          useEffect(() => {
            if (userId) {
              fetchItems(userId);
            } else {
              setCartItems([]);
            }
          }, [userId]);


  const updateQty = (id, change) => {
    console.log("item",id)
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max(1, item.quantity + change) }
          : item
      )
    );
  };

  const removeItem = async(id) => {
   console.log("removr", id)
   try {
       const response = await post(`Order/order-delete/${id}/${userId}`, {
         headers: {
           Authorization: `Bearer ${token}`,
         },
       });
   
       console.log("delete response:", response);
       toast.success("Item deleted successfully!");
       fetchItems(userId);
       // Optionally reset cart or form here
     } catch (error) {
       console.error("Error deleting order:", error);
       toast.error("Failed to delete order");
     }
  };

  const subtotal = cartItems?.reduce((sum, item) => sum + item.quantity * item.price, 0);

const handleCheckout = async () => {
  if (!cartItems || cartItems.length === 0) {
    toast.error("Cart must have at least one item.");
    return;
  }

 

  const payload = cartItems.map((item) => ({
    orderId: item.id,
    quantity: item.quantity,
    totalAmount: item.price * item.quantity,
    updatedBy: userId,
  }));

  console.log("payload", JSON.stringify(payload));
  try {
    const response = await post("Order/update-cart", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Order API response:", response);
    navigate('/delivery')
    // Optionally reset cart or form here
  } catch (error) {
    console.error("Error placing order:", error);
    toast.error("Failed to Save order");
  }

};

 return (

    <div className="container">
      <form className="row g-3">
        <div className="card h-100">
          <div className="card-body">
            <h4 className="mb-4">Your Cart</h4>

            <div className="table-responsive">
              <table className="table align-middle">
                <thead >
                  <tr>
                    <th style={{ width: '50%', fontSize:'14px' }}>Product</th>
                    <th style={{ width: '25%' , fontSize:'14px'}}>Quantity</th>
                    <th style={{ width: '25%' , fontSize:'14px'}}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <div className="d-flex">
                          <img
                            src={`${baseUrl}${item.image}`}
                            alt="item"
                            className="me-3"
                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                          />
                          <div>
                            <h5 className="mb-1" style={{color:'#1C355E'}}>{item.title}</h5>
                            <h6 className="mb-1" style={{color:'#1C355E'}}>Rs. {item.price}/-</h6>
                            <h6 className="mb-1" style={{color:'#1C355E'}}>
                              Height: {item.height} </h6>
                             <h6 className="mb-1" style={{color:'#1C355E'}}> Season: {item.season} </h6>
                            <h6 className="mb-1" style={{color:'#1C355E'}}>  Class: {item.className}</h6>
                            
                          </div>
                        </div>
                      </td>
                     <td>
  <div className="d-flex align-items-center">
    {/* Quantity Box */}
    <div
      className="d-flex align-items-center justify-content-between px-2 py-1"
      style={{
        border: '1px solid #ccc',
        borderRadius: '6px',
        width: '130px',
      }}
    >
      <button
        type="button"
        className="btn btn-sm p-1"
        style={{ border: 'none', background: 'none' }}
        onClick={() => updateQty(item.id, -1)}
      >
        -1
      </button>

      <span className="btn btn-sm p-1" style={{ color: '#1C355E' }}>
        {item.quantity}
      </span>

      <button
        type="button"
        className="btn btn-sm p-1"
        style={{ border: 'none', background: 'none' }}
        onClick={() => updateQty(item.id, 1)}
      >
        +1
      </button>
    </div>

    {/* Delete Icon - aligned inline but outside border */}
    <DeleteOutlineOutlinedIcon
      className="ms-3 "
      style={{ cursor: 'pointer', color :'#1C355E' }}
      onClick={() => removeItem(item.id)}
    />
  </div>
</td>

                      <td style={{color:'#1C355E', fontSize:'16px', fontWeight:'bold'}}>Rs. {item.price * item.quantity}/-</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Subtotal & Checkout */}
            <div className="d-flex justify-content-end align-items-center mt-4">
              <div className="text-end">
                <h5 style={{color:'#1C355E'}}>Subtotal: Rs. {subtotal} PKR</h5>
                <button type='button' className="btn mt-2" style={{backgroundColor:'#1C355E', color:'white'}} 
                onClick={handleCheckout}
                >Checkout</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
export default Checkout
